import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../Footer";

const Feedback = () => {
  const location = useLocation();
  const carArray = location.state?.data;
  const [car] = useState(carArray?.data || {});
  const [formData, setFormData] = useState({
    title: "Feedback - Help us to improve Trusted Cars",
    name: "",
    email: "",
    phone: "",
    message: "",
    contact_consent: 0
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  // Validation rules
  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email is invalid";
    }

    if (!formData.message.trim()) {
      newErrors.message = "Message is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value
    });
    
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: ""
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const response = await fetch(window.CARLOCA_API + "/send/feedback", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (response.ok) {
        setSubmitStatus("success");
        // Reset form on successful submission
        setFormData({
          title: "Feedback - Help us to improve Trusted Cars",
          name: "",
          email: "",
          phone: "",
          message: "",
          contact_consent: 0
        });
      } else {
        setSubmitStatus("error");
        console.error("Feedback submission failed:", data);
      }
    } catch (error) {
      setSubmitStatus("error");
      console.error("Error submitting feedback:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Navbar />
      <div className="container-fluid py-5 mt-md-5 mt-4" style={{ backgroundColor: "#f7f9fc", minHeight: "100vh" }}>
        <div className="row justify-content-center">
          <div className="col-lg-8 feedback-form col-md-10">
            <div className="text-center mb-5">
              <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" className="mb-3">
                <path fill="#00889C" d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 9h-2V5h2v6zm0 4h-2v-2h2v2z" />
              </svg>
              <h2 className="fw-bold" style={{ color: "#00889C" }}>Share Your Feedback</h2>
              <p className="text-muted">We value your opinion and would love to hear from you</p>
            </div>

            <div className="card shadow-lg border-0 rounded-3 overflow-hidden">
              <div className="card-header py-4 text-white text-center" style={{ backgroundColor: "#00889C" }}>
                <h4 className="mb-0">Help Us Improve</h4>
              </div>

              <div className="card-body p-4 p-md-5">
                {submitStatus === "success" && (
                  <div className="alert alert-success alert-dismissible fade show" role="alert">
                    <strong>Thank you!</strong> Your feedback has been submitted successfully.
                    <button type="button" className="btn-close" onClick={() => setSubmitStatus(null)}></button>
                  </div>
                )}

                {submitStatus === "error" && (
                  <div className="alert alert-danger alert-dismissible fade show" role="alert">
                    <strong>Error!</strong> There was a problem submitting your feedback. Please try again.
                    <button type="button" className="btn-close" onClick={() => setSubmitStatus(null)}></button>
                  </div>
                )}

                <form onSubmit={handleSubmit}>
                  <div className="mb-4">
                    <label htmlFor="title" className="form-label fw-semibold">Feedback Type</label>
                    <select
                      id="title"
                      name="title"
                      className="form-control form-control-lg"
                      value={formData.title}
                      onChange={handleChange}
                    >
                      <option value="Feedback - Help us to improve Trusted Cars">General Feedback</option>
                      <option value="Bug Report">Bug Report</option>
                      <option value="Feature Request">Feature Request</option>
                      <option value="Complaint">Complaint</option>
                      <option value="Compliment">Compliment</option>
                    </select>
                  </div>

                  <div className="row">
                    <div className="col-md-6 mb-4">
                      <label htmlFor="name" className="form-label fw-semibold">Full Name *</label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className={`form-control form-control-lg ${errors.name ? "is-invalid" : ""}`}
                        placeholder="Your name"
                        value={formData.name}
                        onChange={handleChange}
                      />
                      {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                    </div>

                    <div className="col-md-6 mb-4">
                      <label htmlFor="email" className="form-label fw-semibold">Email Address *</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className={`form-control form-control-lg ${errors.email ? "is-invalid" : ""}`}
                        placeholder="your.email@example.com"
                        value={formData.email}
                        onChange={handleChange}
                      />
                      {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                    </div>
                  </div>

                  <div className="mb-4">
                    <label htmlFor="phone" className="form-label fw-semibold">Phone Number</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      className="form-control form-control-lg"
                      placeholder="Your phone number (optional)"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="mb-4">
                    <label htmlFor="message" className="form-label fw-semibold">Your Message (Feedback) *</label>
                    <textarea
                      id="message"
                      name="message"
                      rows="5"
                      className={`form-control textarea-height   ${errors.message ? "is-invalid" : ""}`}
                      placeholder="Please share your thoughts, suggestions, or concerns..."
                      value={formData.message}
                      onChange={handleChange}
                    ></textarea>
                    {errors.message && <div className="invalid-feedback">{errors.message}</div>}
                  </div>
                  <div className="mb-4">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="contact_consent"
                        name="contact_consent"
                        value='1'
                        checked={formData.contact_consent}
                        onChange={handleChange}
                      />
                      <label className="form-check-label" style={{ fontSize: "16px" }} htmlFor="contact_consent">
                        Is it okay if we reach out with any questions about your feedback?
                      </label>
                    </div>
                  </div>
                  <div className="d-grid">
                    <button
                      type="submit"
                      className="btn btn-lg text-white fw-semibold py-3"
                      style={{ backgroundColor: "#00889C" }}
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Submitting...
                        </>
                      ) : (
                        "Submit Feedback"
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>

            <div className="text-center mt-4">
              <p className="text-muted">
                Have questions? <a href="mailto:info@trustedcars.in" style={{ color: "#C65D1A", textDecoration: "none" }}>Contact us directly</a>
              </p>
              <Link to="/" className="btn btn-outline-secondary">
                Return to Home
              </Link>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Feedback;